import React, { FC, MouseEvent, ReactNode } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogActions, DialogContent, Grid, Typography } from '@material-ui/core';

import i18n from 'config/i18n';

const defaultProps = {
  message: i18n.t('components:alertMessage'),
  cancel: i18n.t('common:cancel'),
  confirm: i18n.t('common:confirm'),
};

interface IProps {
  open: boolean;
  onConfirm: (event: MouseEvent<HTMLButtonElement>) => void;
  onCancel: () => void;
  message?: string | ReactNode;
  cancel?: string | ReactNode;
  confirm?: string | ReactNode;
}

const useStyles = makeStyles(theme => ({
  content: {
    padding: theme.spacing(5),
    '&:first-child': {
      paddingTop: theme.spacing(5),
    },
  },
  button: {
    padding: theme.spacing(1, 3),
    borderRadius: 4,
    flex: 2,
  },
  actions: {
    margin: theme.spacing(4, 0, 0, 0),
    justifyContent: 'center',
  },
  gutter: {
    flex: 1,
  },
}));

const Alert: FC<IProps> = ({ open, onConfirm, onCancel, message, cancel, confirm }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogContent className={classes.content}>
        <Typography gutterBottom align="center" variant="subtitle2">
          {message}
        </Typography>
        <DialogActions classes={{ root: classes.actions }}>
          <Grid item className={classes.gutter} />
          <Button variant="contained" onClick={onCancel} className={classes.button}>
            {cancel}
          </Button>

          <Button
            color="primary"
            variant="contained"
            onClick={onConfirm}
            autoFocus
            className={classes.button}>
            {confirm}
          </Button>
          <Grid item className={classes.gutter} />
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

Alert.defaultProps = defaultProps;

export default Alert;
